// 챗봇 답변의 마크다운 부분집합(굵게·코드·기울임·목록·제목) → React 노드.
// HTML 문자열을 만들지 않고 엘리먼트로만 구성한다(모델 출력 주입 방지).
import React from 'react';

// 링크는 앵커로 만들지 않고 "글자 (주소)" 평문으로 바꾼다.
function stripLinks(s) {
  return s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, '$1 ($2)');
}

// 각 규칙: 1번 그룹 = 앞 문맥(보존), 2번 그룹 = 안쪽 글자
var INLINE = [
  { re: /()\*\*([^*]+?)\*\*/, tag: 'strong' },
  { re: /()`([^`]+)`/, tag: 'code' },
  { re: /(^|[^\w*_])[*_]([^*_\s](?:[^*_]*[^*_\s])?)[*_](?![\w*_])/, tag: 'em' }
];

function parseText(s, level, keyBase) {
  if (level >= INLINE.length) return s ? [s] : [];
  var re = INLINE[level].re;
  var tag = INLINE[level].tag;
  var m = re.exec(s);
  if (!m) return parseText(s, level + 1, keyBase);
  var k = keyBase + '-' + level + '-' + m.index;
  var mid = tag === 'code' ? [m[2]] : parseText(m[2], level + 1, k);
  var el = React.createElement.apply(React, [tag, { key: k }].concat(mid));
  return parseText(s.slice(0, m.index) + m[1], level, k + 'a')
    .concat([el])
    .concat(parseText(s.slice(m.index + m[0].length), level, k + 'b'));
}

// bold/code/italic 조각 배열(문자열 + 엘리먼트)
export function parseInline(line) {
  return parseText(stripLinks(String(line == null ? '' : line)), 0, 'i');
}

var UL = /^\s*[-*•]\s+(.*)$/;
var OL = /^\s*\d+\.\s+(.*)$/;
var HEAD = /^\s*#{1,6}\s+(.*)$/;

export function renderMarkdown(text) {
  if (typeof text !== 'string' || !text) return [];
  var out = [];
  var lines = text.replace(/\r\n?/g, '\n').split('\n');
  var i = 0;
  function key() { return 'b' + out.length; }
  while (i < lines.length) {
    var line = lines[i];
    if (!line.trim()) { i++; continue; }
    var list = UL.test(line) ? { re: UL, tag: 'ul' } : OL.test(line) ? { re: OL, tag: 'ol' } : null;
    if (list) {
      var items = [];
      while (i < lines.length && list.re.test(lines[i])) {
        items.push(<li key={'li' + items.length}>{parseInline(list.re.exec(lines[i])[1])}</li>);
        i++;
      }
      out.push(React.createElement(list.tag, { key: key() }, items));
    } else if (HEAD.test(line)) {
      out.push(<p key={key()}><strong>{parseInline(HEAD.exec(line)[1])}</strong></p>);
      i++;
    } else {
      var parts = [];
      while (i < lines.length && lines[i].trim() && !UL.test(lines[i]) && !OL.test(lines[i]) && !HEAD.test(lines[i])) {
        if (parts.length) parts.push(<br key={'br' + parts.length} />);
        parts.push(<React.Fragment key={'l' + parts.length}>{parseInline(lines[i])}</React.Fragment>);
        i++;
      }
      out.push(<p key={key()}>{parts}</p>);
    }
  }
  return out;
}
